import React from 'react'
import { EnterEmail } from '@piconetworks/login'
import withInjection from '@piconetworks/with-injection'
import { colors } from '@piconetworks/functions'

import { bindActionCreators } from 'redux'
import Account from 'common/modules/account'
import Auth from 'common/modules/auth'
import Loader from 'common/modules/loader'
import Wizard from 'common/modules/wizard'
import Zoid from 'common/modules/zoid'
import Arbiter from 'common/modules/arbiter'
import Internal from 'common/modules/internal'

import WizardRedux, { WizardLoading, WizardError } from 'common/pkgs/WizardRedux'

import xFrame from 'common/xFrame'

const mapStateToProps = (state, props) => {
    const linkColor = Loader.selectors.linkColor(state)
    const signupFormEmail = state.account.email
    const checkoutWizard = state?.wizard?.wizards.CheckoutWizard
    const registrationWizard = state?.wizard?.wizards.RegistrationWizard
    const loginWizard = state?.wizard?.wizards.LoginWizard
    const query = loginWizard?.submit?.payload?.url?.query || {}
    const useLoginText = Object.keys(query).length === 0

    let ruleTexts = {}
    let getRuleTexts = () => ({})

    try {
        ruleTexts = Loader.selectors.ruleTexts(state, 'guest')
        getRuleTexts = (scope) => Loader.selectors.ruleTexts(state, scope)
    } catch (error) {
        /* continue regardless of error */
    }

    const getWording = (textKeyName) => {
        if (!textKeyName) {
            return {}
        }

        const text = {
            checkout: {
                title: 'Create an account.',
                subTitle: 'Continue below to create an account and complete your payment.',
            },
            registration: ruleTexts.prompt || {},
            login: {
                title: 'Welcome back!',
                subTitle: 'Log in below to continue where you left off.',
            },
            signupForm: {
                title: 'Please confirm your email address.',
            },
        }

        return {
            title: text[textKeyName].title,
            subTitle: text[textKeyName].subTitle,
            description: text[textKeyName].description,
        }
    }

    let wordingKey

    if (useLoginText) {
        wordingKey = 'login'
    } else if (registrationWizard) {
        wordingKey = 'registration'
    } else if (signupFormEmail) {
        wordingKey = 'signupForm'
    } else if (checkoutWizard) {
        wordingKey = 'checkout'
    }

    const wording = getWording(wordingKey)

    return {
        ...props,
        newsletterBgColor: colors.getBgColor(linkColor, 0.05),
        hasPassword: state.account.hasPassword,
        hasPasswordError: state.account.hasPasswordError,
        isFetching: state.account.isFetching,
        checkoutWizard,
        loginWizard,
        utmRootUrl: process.env.MARKETING_SITE_URL,
        registrationWizard,
        thisWizard: Wizard.selectors.thisWizard({ state, router: props.router }),
        scope: state.loader.user ? 'user' : 'guest',
        getScopedLoader: (scope) => Loader.selectors.scopedLoader(state, scope),
        getRuleTexts,
        currentPlanTierId: Loader.selectors.currentPlanTierId(state),
        publisherId: Loader.selectors.publisherId(state),
        WizardRedux,
        WizardLoading,
        WizardError,
        userId: state?.loader?.guest?.user?.id,
        access_token: state?.loader?.guest?.token,
        utm: Zoid.selectors.getUTM(state),
        signupFormEmail,
        queryOverride: {
            utmCampaign: state?.zoid?.tag,
            utmSource: Loader.selectors.publisherName(state),
            utmMedium: process.env.HOSTNAME,
            utmContent: 'EnterEmail',
            rootUrl: process.env.MARKETING_SITE_URL,
        },
        Wording: {
            Title: (
                <>
                    {wording.title}
                </>
            ),
            SubTitle: (
                <>
                    {wording.subTitle}
                </>
            ),
            Description: (
                <>
                    {wording.description}
                </>
            ),
        },
        wordingKey,
    }
}

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({
        getHasPassword: Account.creators.getHasPassword,
        socialLogin: Auth.creators.socialLogin,
        sendExternalLink: (payload) => dispatch(Internal.creators.sendMessage({
            payload: {
                target: 'pico_arbiter',
                ...Arbiter.creators.sendExternalLink({
                    payload,
                }),
            },
        })),
    }, dispatch),
    showHeaderRoute: (wordingKey) => {
        const headerRouteMap = {
            registration: {
                url: {
                    pathname: '/header-bar',
                    query: {
                        useDefault: true,
                    },
                },
            },
            login: {
                url: {
                    pathname: '/header-bar',
                    query: {
                        hideLogin: true,
                    },
                },
            },
        }

        const payload = headerRouteMap[wordingKey]

        xFrame.prompt.showHeaderRoute({
            dispatch,
            payload,
        })
    },
    newsletterSubscribe: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Account.creators.newsletterSubscribe,
        dispatch,
    }),
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    dispatchProps.showHeaderRoute(stateProps.wordingKey)

    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
    }
}

const InjectedEnterEmail = withInjection(EnterEmail, {
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
})

export default InjectedEnterEmail
